import React, { FC } from 'react';
import { Heading, Card, Box } from '@deckee/deck-hand';
import styled from 'styled-components';
import VerifiedBadge from '../VerifiedBadge/VerifiedBadge';

interface MarketplaceListingHeadingProps {
  name: string;
  partner: boolean;
}

const MarketplaceListingHeading: FC<MarketplaceListingHeadingProps> = ({
  name,
  partner,
}) => (
  <Card.Heading
    // height="initial"
    // level={4}
    display="flex"
    alignItems="center"
    justifyContent="space-between"
  >
    <span>{name}</span>

    {partner && <VerifiedBadge />}
  </Card.Heading>
);
export default MarketplaceListingHeading;
